export default __webpack_public_path__ + "static/make-your-data-work-for-you-bg-9493cc47f3546a1bc122f9838109a23d.svg";